import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import HeroSection from "./components/HeroSection";
import GuaranteesSection from "./components/GuaranteesSection";
import ProcessSection from "./components/ProcessSection";
import CategoriesSection from "./components/CategoriesSection";
import PromiseSection from "./components/PromiseSection";
import FaqPreviewSection from "./components/FaqPreviewSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  useSeo({
    title: "爆料51匿名通道 | 隐私保护·保密机制·安全爆料不露面",
    description:
      "爆料51匿名通道采用隐私保护与保密机制处理每一条信息，支持匿名投稿与安全爆料，让你不必露面就能安心说出你知道的。了解安全投稿流程与身份保护建议。",
    keywords: "爆料51,爆料51匿名爆料,爆料51隐私保护,匿名投稿,保密机制,安全爆料",
    path: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.fullName,
        url: "https://cwxxkj.cn/",
        email: siteInfo.email,
        description: siteInfo.shortDesc,
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.fullName,
        url: "https://cwxxkj.cn/",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "爆料51匿名通道 | 隐私保护·保密机制·安全爆料不露面",
        url: "https://cwxxkj.cn/",
        description: "匿名投稿与安全爆料通道，全程隐私保护与保密机制处理。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 5).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <GuaranteesSection />
      <ProcessSection />
      <CategoriesSection />
      <PromiseSection />
      <FaqPreviewSection />
      <CtaSection />
    </SiteLayout>
  );
}